/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { PlaidService } from '../../../shared/services/plaid.service';
import { FlowManagerService } from '../../../shared/services/flowmanager.service';

@Component({
  selector: 'ns-funding-choices',
  template: require('./funding-choices.component.html')
})

export class FundingChoicesComponent extends BaseRoute {

  isIRA = false;

  constructor(
    injector: Injector,
    plaid: PlaidService,
    flowManager: FlowManagerService) {
    super(injector);
    this.plaid = plaid;
    this.flowManager = flowManager;
  }

  ngOnInit() {
    // Get the names on the account
    this.appInfo = this.appActions.getData('ApplicationInformation');
    this.investAccount = this.appActions.getData('DepositFunds.to');
    this.form.inputs.investAccount.noneditable = (this.investAccount) ? this.investAccount : '';
    this.isIRA = this.flowManager.isIra;


    // Uncomment to test this page
    // this.appInfo = {
    //   signature: {
    //     name: 'Alberta Charleson Bobbeth' // Use 'Alberta Charleson Bobbeth' for test plaid user
    //   }
    // };


    const names = [this.appInfo.signature.name];
    if (this.appInfo.jointAccountSignature !== (null || undefined)) {
      names.push(this.appInfo.jointAccountSignature.name);
    }

    this.appActions.setData('FundAccount.accountHoldersName', this.appInfo.signature.name);

    this.plaid.onSuccess((publicToken, argMetadata) => {
      this.modal.plaidLoadingModel();

      this.noAchSupport = false;
      this.isError = false;
      this.blackListed = false;

      const metadata = {
        request_id: this.request_id,
        public_token: argMetadata.public_token,
        id: argMetadata.account.id,
        bankName: argMetadata.institution.name.replace(/[^a-zA-Z1-9 ]/g, '')
      };

      this.appProxy.plaidInit({ publicToken, metadata, names }, resp => {
        this.appActions.setData('FundAccount', resp.result);
        this.flowManager.isOneAllyBank = false;

        if (resp.result.blackListed === true) return this._blackListed();
        if (resp.status === 401) return this._badName(resp.result);
        if (resp.result.showAbaRouting === true) return this._showABARouting();
        if (resp.result.plaidSuccess === true) return this._passed();
        return null;
      });
    });

    this.plaid.onEvent((eventName, metadata) => {
      if (eventName === 'HANDOFF') {
        this.request_id = metadata.request_id;
      }
      // Plaid error logging
      if (eventName === 'ERROR') {
        this.tempObject = metadata;
      }

      if (eventName === 'TRANSITION_VIEW' && metadata.request_id !== null && metadata.request_id !== this.request_id && this.tempObject !== undefined) {
        this.request_id = metadata.request_id;
        this.tempObject.request_id = metadata.request_id;
        this.appProxy.plaidError(this.tempObject, () => delete this.tempObject);
      }

      if (eventName === 'SELECT_INSTITUTION') {
        // REMOVE THIS WHEN PLAID SUPPORTS CAPITAL ONE AGAIN
        // Check for Capital One selection (not currently supported by Plaid)
        if (metadata.institution_id === 'ins_9') {
          this.appActions.setData('FundAccount.bankName', metadata.institution_name);
          this.plaid.close();
          this.router.navigate(['/fund-account']);
        }
      }
    });

    this.plaid.onExit((err, metadata) => {
      if (metadata.status === 'institution_not_found') {
        this.router.navigate(['/fund-account']);
      }
    });
  }

  _blackListed() {
    this.blackListed = true;
    this.modal.closeModal();
  }

  _badName(data) {
    if (data.nameFailout === true) {
      this.appActions.setData('FundAccount.nameFailout', true);
      this.modal.closeModal('verify-ach-profile-failed');
      return;
    }
    this.isError = true;
    this.modal.closeModal();
  }

  _showABARouting() {
    this.modal.closeModal('fund-aba-routing');
  }

  _passed() {
    this.modal.closeModal('verify-ach-profile-passed');
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  btnClick(e) {
    if (e.action === 'next') {
      this.appActions.clearData('FundAccount');
      this.appActions.setData('FundAccount.accountHoldersName', this.appInfo.signature.name);
      this.plaid.open();
    } else if (e.action === 'fund_later') {
      this.flowManager.fundLaterRouting();
    }
  }
}
